'use client';

import React from 'react';
import { PHASE_META } from '@/lib/curriculum';

interface PhaseFilterChipsProps {
  activePhase: number | null;
  onSelectPhase: (phase: number | null) => void;
}

export default function PhaseFilterChips({ activePhase, onSelectPhase }: PhaseFilterChipsProps) {
  return (
    <div
      style={{
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
      }}
      role="group"
      aria-label="Filter by phase"
    >
      {/* All chip */}
      <button
        onClick={() => onSelectPhase(null)}
        style={{
          padding: '6px 14px',
          borderRadius: '20px',
          border: `1px solid ${activePhase === null ? 'var(--accent-border)' : 'var(--border)'}`,
          backgroundColor: activePhase === null ? 'var(--accent-glow)' : 'var(--bg-elevated)',
          color: activePhase === null ? 'var(--accent)' : 'var(--text-secondary)',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: 500,
          transition: 'all 150ms ease',
          whiteSpace: 'nowrap',
        }}
      >
        All Phases
      </button>

      {[1, 2, 3, 4, 5, 6].map(phase => {
        const meta = PHASE_META[phase];
        const isActive = activePhase === phase;
        return (
          <button
            key={`phase-chip-${phase}`}
            onClick={() => onSelectPhase(isActive ? null : phase)}
            style={{
              padding: '6px 14px',
              borderRadius: '20px',
              border: `1px solid ${isActive ? meta.border : 'var(--border)'}`,
              backgroundColor: isActive ? meta.color : 'var(--bg-elevated)',
              color: isActive ? meta.textColor : 'var(--text-secondary)',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 500,
              transition: 'all 150ms ease',
              whiteSpace: 'nowrap',
            }}
            onMouseEnter={e => {
              if (!isActive) {
                (e.currentTarget as HTMLElement).style.backgroundColor = meta.color;
                (e.currentTarget as HTMLElement).style.color = meta.textColor;
                (e.currentTarget as HTMLElement).style.borderColor = meta.border;
              }
            }}
            onMouseLeave={e => {
              if (!isActive) {
                (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--bg-elevated)';
                (e.currentTarget as HTMLElement).style.color = 'var(--text-secondary)';
                (e.currentTarget as HTMLElement).style.borderColor = 'var(--border)';
              }
            }}
          >
            P{phase} · {meta.label}
          </button>
        );
      })}
    </div>
  );
}